import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function updateCompany (params = null, idCIFEmpresa) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      const data = mock.getLocations
      const pages = data.data.length

      const clone = JSON.parse(JSON.stringify(data))
      if (params !== null) {
        console.log(clone.data)
        clone.data = clone.data.slice(0, params.limit)
      }

      clone.meta.total = pages

      resolve(clone)
    })
  } else {
    const req = {
      url: '/api/cifsempresa/actualizarcif',
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data: params,
      params: {
        idCIFEmpresa: idCIFEmpresa
      }
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { updateCompany }
